export default {
    SET_EMAIL: (state, email) => {
        state.email = email
    },

    SET_ACTIVE_TYPE: (state, type) => {
        state.type = type
    },

    SET_ACTIVE_LEADER: (state, leader) => {
        state.activeLeader = leader
    },

    RESET_CREATE_ACCOUNT: (state) => {
        state.email = null
        state.activeLeader = null
    }
}
